'use client';

import React from 'react';
import { Card } from '../../atoms/Card';
import { Combo } from '@/types/combo';
import Imagem from '@/components/atoms/Imagem';
import * as S from './styles';
import { useTheme } from 'styled-components';
import Link from 'next/link';

export default function Plano(props: Combo) {
  const { imagem, imagemCarrossel, imagemMobile, descricao, slug } = props;
  const theme = useTheme();

  return (
    <Link href={`/plano/${slug}`}>
      <Card
        $size={3}
        $insetContent={true}
        $variant="surface"
        $interactive={false}
      >
        <S.PlanoImagem>
          <Imagem
            imagemUrl={imagemCarrossel ?? imagemMobile ?? imagem}
            priority={true}
            descricaoImagem={descricao}
            style={{
              objectFit: 'cover',
              borderRadius: theme.radius[4],
            }}
            propsNextImage={{
              unoptimized: true,
            }}
          />
        </S.PlanoImagem>
      </Card>
    </Link>
  );
}
